import { ApiError, ApiTransportError } from './errors.js';
/** Conservative default: one extra attempt, GET only, ~300ms→600ms backoff. */
export const DEFAULT_RETRY_POLICY = {
    retries: 1,
    baseDelayMs: 300,
    maxDelayMs: 2000,
};
/** No retry at all — the default for write requests. */
export const NO_RETRY = {
    retries: 0,
    baseDelayMs: 0,
    maxDelayMs: 0,
};
/** The built-in eligibility rule (see file header). */
export function defaultIsRetryable(error) {
    if (error instanceof ApiTransportError) {
        return true;
    }
    if (error instanceof ApiError) {
        return error.status >= 500;
    }
    return false;
}
/**
 * Resolves the effective policy for one request: per-request override wins,
 * `false` disables, and writes fall back to NO_RETRY even under a client-wide
 * policy unless the policy explicitly lists the method.
 */
export function resolveRetryPolicy(clientPolicy, override, method) {
    const base = override === false ? NO_RETRY : (override ?? clientPolicy);
    const methods = base.methods ?? (method === 'GET' ? ['GET'] : []);
    const retries = methods.includes(method) ? Math.max(0, base.retries) : 0;
    return {
        retries,
        baseDelayMs: Math.max(0, base.baseDelayMs),
        maxDelayMs: Math.max(base.maxDelayMs, base.baseDelayMs, 0),
        isRetryable: base.isRetryable ?? defaultIsRetryable,
    };
}
/** Full-jitter backoff: uniform in [0, min(maxDelayMs, baseDelayMs * 2^attempt)]. */
export function retryDelayMs(policy, attempt) {
    const cap = Math.min(policy.maxDelayMs, policy.baseDelayMs * 2 ** attempt);
    return Math.random() * cap;
}
/** setTimeout-based sleep, exported for tests and the csrf-client. */
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
//# sourceMappingURL=retry.js.map